var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_company_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PHASE-II",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-667.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(593.000000, 450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(74.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_company_logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default_image"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#CAD3C0",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8,24 C45.3349651,24 45.8345352,24.2673618 46.1312805,24.7124797 L46.1312805,24.7124797 L48.8576,28.8 L54.4,28.8 C56.9907176,28.8 59.1020574,30.8524599 59.1966892,33.4200494 L59.1966892,33.4200494 L59.2,33.6 L59.2,51.2 C59.2,53.8509668 57.0509668,56 54.4,56 L54.4,56 L25.6,56 C22.9490332,56 20.8,53.8509668 20.8,51.2 L20.8,51.2 L20.8,33.6 C20.8,30.9490332 22.9490332,28.8 25.6,28.8 L25.6,28.8 L31.1432,28.8 L33.8687195,24.7124797 C34.140736,24.304455 34.5831817,24.0457947 35.067093,24.0055182 L35.067093,24.0055182 L35.2,24 Z M43.944,27.2 L36.0568,27.2 L33.3312805,31.2875203 C33.059264,31.695545 32.6168183,31.9542053 32.132907,31.9944818 L32.132907,31.9944818 L32,32 L25.6,32 C24.7163444,32 24,32.7163444 24,33.6 L24,33.6 L24,51.2 C24,52.0836556 24.7163444,52.8 25.6,52.8 L25.6,52.8 L54.4,52.8 C55.2836556,52.8 56,52.0836556 56,51.2 L56,51.2 L56,33.6 C56,32.7163444 55.2836556,32 54.4,32 L54.4,32 L48,32 C47.4650349,32 46.9654648,31.7326382 46.6687195,31.2875203 L46.6687195,31.2875203 L43.944,27.2 Z M40,33.6 C44.418278,33.6 48,37.181722 48,41.6 C48,46.018278 44.418278,49.6 40,49.6 C35.581722,49.6 32,46.018278 32,41.6 C32,37.181722 35.581722,33.6 40,33.6 Z M40,36.8 C37.3490332,36.8 35.2,38.9490332 35.2,41.6 C35.2,44.2509668 37.3490332,46.4 40,46.4 C42.6509668,46.4 44.8,44.2509668 44.8,41.6 C44.8,38.9490332 42.6509668,36.8 40,36.8 Z",
    id: "Combined-Shape",
    fill: "#E0EAD5",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconWithBg);
export default __webpack_public_path__ + "static/media/camera-icon-with-bg.132b92593c2e5d8dfc9d6e5a6a3e1efc.svg";
export { ForwardRef as ReactComponent };